import type { RouteDefinition } from "../route-definition.ts";

export const adminLeaguesRoutes = {
  "admin.leaguePerformance": {
    path: "/admin/leagues/:leagueId/performance",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueRounds": {
    path: "/admin/leagues/:leagueId/rounds",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueParticipants": {
    path: "/admin/leagues/:leagueId/participants",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueSettings": {
    path: "/admin/leagues/:leagueId/settings",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueDiagnostics": {
    path: "/admin/leagues/:leagueId/diagnostics",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueTraining": {
    path: "/admin/leagues/:leagueId/training",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagues": {
    path: "/admin/leagues",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.leaguesHealth": {
    path: "/admin/leagues/health",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.league": {
    path: "/admin/leagues/:leagueId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueHealth": {
    path: "/admin/leagues/:leagueId/health",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueActivity": {
    path: "/admin/leagues/:leagueId/activity",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueRoster": {
    path: "/admin/leagues/:leagueId/roster",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.leagueSimulation": {
    path: "/admin/leagues/:leagueId/simulation",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
